import { RESET_STATE } from 'store/global/actions';

import { GUARDRAIL_ACTION_TYPE } from '../actions';

const initialQueryState = { data: [], isLoading: false, hasError: false };

// versions carries the channelId scope it was fetched FOR (null = company-wide) — the page drops a
// mismatched chain instead of briefly rendering the previous scope's history after a scope switch.
const initialState = {
  list: initialQueryState,
  versions: { ...initialQueryState, channelId: undefined },
  save: { isSaving: false, errorMessage: null },
  budgetStatus: initialQueryState,
};

const upsertGuardrail = (rows, row) => {
  const exists = rows.some(item => item.marginGuardrailConfigId === row.marginGuardrailConfigId);

  if (exists) {
    return rows.map(item =>
      item.marginGuardrailConfigId === row.marginGuardrailConfigId ? row : item,
    );
  }

  // A new version supersedes the prior current row for its scope — drop that row (if present) and add
  // the new one, so `list` always reflects only the CURRENT row per scope.
  return [...rows.filter(item => item.channelId !== row.channelId), row];
};

const guardrailReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GUARDRAIL_ACTION_TYPE.SET_LOADING:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: payload,
          hasError: payload ? false : state.list.hasError,
        },
      };

    case GUARDRAIL_ACTION_TYPE.SET_ERROR:
      return { ...state, list: { ...state.list, isLoading: false, hasError: true } };

    case GUARDRAIL_ACTION_TYPE.GET_GUARDRAILS:
      return { ...state, list: { data: payload ?? [], isLoading: false, hasError: false } };

    case GUARDRAIL_ACTION_TYPE.SET_VERSIONS_LOADING:
      return {
        ...state,
        versions: {
          ...state.versions,
          isLoading: payload,
          hasError: payload ? false : state.versions.hasError,
        },
      };

    case GUARDRAIL_ACTION_TYPE.SET_VERSIONS_ERROR:
      return { ...state, versions: { ...state.versions, isLoading: false, hasError: true } };

    case GUARDRAIL_ACTION_TYPE.GET_GUARDRAIL_VERSIONS:
      return {
        ...state,
        versions: {
          channelId: payload?.channelId,
          data: payload?.data ?? [],
          isLoading: false,
          hasError: false,
        },
      };

    case GUARDRAIL_ACTION_TYPE.SET_SAVING:
      return { ...state, save: { isSaving: payload, errorMessage: null } };

    case GUARDRAIL_ACTION_TYPE.SET_SAVE_ERROR:
      return { ...state, save: { isSaving: false, errorMessage: payload ?? null } };

    case GUARDRAIL_ACTION_TYPE.UPSERT_GUARDRAIL:
      return {
        ...state,
        list: { ...state.list, data: upsertGuardrail(state.list.data, payload) },
        versions:
          state.versions.channelId === (payload.channelId ?? null)
            ? { ...state.versions, data: [payload, ...state.versions.data] }
            : state.versions,
        save: { isSaving: false, errorMessage: null },
      };

    case GUARDRAIL_ACTION_TYPE.SET_BUDGET_STATUS_LOADING:
      return {
        ...state,
        budgetStatus: {
          ...state.budgetStatus,
          isLoading: payload,
          hasError: payload ? false : state.budgetStatus.hasError,
        },
      };

    case GUARDRAIL_ACTION_TYPE.SET_BUDGET_STATUS_ERROR:
      return {
        ...state,
        budgetStatus: { ...state.budgetStatus, isLoading: false, hasError: true },
      };

    case GUARDRAIL_ACTION_TYPE.GET_CONCESSION_BUDGET_STATUS:
      return { ...state, budgetStatus: { data: payload ?? [], isLoading: false, hasError: false } };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default guardrailReducer;
